import { render, staticRenderFns } from "./FlightObserverView.vue?vue&type=template&id=36563d4a"
import script from "./FlightObserverView.vue?vue&type=script&lang=js"
export * from "./FlightObserverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports